import { findFirstNonEmptyString } from "@product/scmp-sdk";
import type { ShareButtonProps, SharePositionType, SocialShareType } from "@product/scmp-sdk";
import uniq from "lodash/uniq";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { contentShareWidgetContent$key } from "~/queries/__generated__/contentShareWidgetContent.graphql";

import { Container, StyledShareButton } from "./styles";

export type Props = {
  onClick?: (type: SocialShareType) => void;
  position?: SharePositionType;
  reference: contentShareWidgetContent$key;
  types: SocialShareType[];
} & Omit<ShareButtonProps, "relativeUrl" | "shortUrl" | "title" | "utm" | "type">;

export const ContentShareWidget: FunctionComponent<Props> = ({
  className,
  onClick,
  position,
  reference: reference_,
  types,
  ...props
}) => {
  const content = useFragment(
    graphql`
      fragment contentShareWidgetContent on Content {
        entityId
        urlAlias
        shortUrl
        socialHeadline
        headline
      }
    `,
    reference_,
  );

  return (
    <Container className={className}>
      {uniq(types).map(type => (
        <StyledShareButton
          className={type}
          key={type}
          position={position}
          relativeUrl={content.urlAlias}
          shortUrl={content.shortUrl}
          title={findFirstNonEmptyString(content.headline, content.socialHeadline)}
          type={type}
          utm={{
            campaign: content.entityId,
            medium: "share_widget",
          }}
          onClick={() => onClick?.(type)}
          {...props}
        />
      ))}
    </Container>
  );
};

ContentShareWidget.displayName = "ContentShareWidget";
